'use strict';

require('../CompanyService.js');
require('./CompanyFlowVerifiesService.js');

function CompanyTagSuggestionCtrl($scope,
  $stateParams,
  growl,
  $http,
  $translate,
  tagSuggestions,
  flowVerifies,
  uploadTracker,
  config,
  CompanyUserService,
  CompanyFlowVerifiesService,
  CompanyService) {

  var nonWatchersPromise;
  $scope.tagSuggestions = tagSuggestions;
  $scope.flowVerifies = flowVerifies;
  $scope.nonWatchers = [];
  var DEFAULT_FLOWVERIFY = {
    name: '',
    watchers: [],
    type: 'MULTI'
  };
  $scope.flowVerifyNew = new CompanyFlowVerifiesService(angular.copy(DEFAULT_FLOWVERIFY));
  $scope.newTime = new Date().getTime();
  $scope.urlBases = [$scope.types.length];
  $scope.urlBase = config.apiBase + "/files/" + $stateParams.companyId + "_pub_";
  angular.forEach($scope.types, function(value, key){
    if(($scope.info.features.publicationTypes.indexOf(value) !== -1) && (value === 'DEFAULT' || value === 'ALBUM' || value === 'FOLDER' || value === 'NOTE' || value === 'FORM' || value === 'PUBLICATION_GROUP')){
      $scope.urlBases[key] = true;
      $http({
        method: 'GET',
        url: config.apiBase + "/files/" + $stateParams.companyId + "_pub_" + value.toLowerCase()
      }).then(function(response){
        if (response.status === 200) {
          $scope.urlBases[key] = true;
        }else{
          $scope.urlBases[key] = false;
        }
      });
    }else{
      $scope.urlBases[key] = false;
    }
  });

  $scope.saveTagSuggestions = function() {
    CompanyService.updateTagSuggestions({companyId: $stateParams.companyId}, $scope.tagSuggestions.map(function(item) {
      return item;
    }));
  };


  $scope.removeTagSuggestion = function(tag) {
    $scope.tagSuggestions.splice(tagSuggestions.indexOf(tag), 1);

    return $scope.saveTagSuggestions();
  };

  $scope.addTagSuggestion = function(tag) {
    if($scope.tagSuggestions.indexOf(tag) === -1) {
      $scope.tagSuggestions.push(tag);

      angular.element('#smartphoneTags').val('');

      return $scope.saveTagSuggestions();
    }
  };

  $scope.addedTags = function(item) {
    return $scope.tagSuggestions.indexOf(item) === -1;
  };

  $scope.updateNonWatchers = function(filter) {
    var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !$scope.flowVerifyNew.watchers.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonWatchers) {
      if(nonWatchersPromise === p) {
        $scope.nonWatchers = nonWatchers;
      }
    });
    nonWatchersPromise = p;
  };

  $scope.addWatcher = function(watcher) {
    $scope.flowVerifyNew.watchers.push(watcher);
    angular.element('#filterWatchers').val('');
    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
  };

  $scope.deleteWatcher = function(watcher) {
    $scope.flowVerifyNew.watchers.splice($scope.flowVerifyNew.watchers.indexOf(watcher), 1);
  };

  $scope.addFlow = function(){
    $scope.flowVerifyNew.$save({companyId: $stateParams.companyId}, function(res){
      growl.addSuccessMessage($translate.instant('flow.add-flow-success'));
      $scope.flowVerifies.push(res);
      $scope.flowVerifyNew = new CompanyFlowVerifiesService(angular.copy(DEFAULT_FLOWVERIFY));
    }, function(){
      growl.addErrorMessage($translate.instant('flow.add-flow-failure'));
    });
  };

  $scope.deleteFlowVerify = function(flowVerify){
    $scope.flowVerifyNew.$delete({companyId: $stateParams.companyId, flowVerifyID: flowVerify.id}, function(){
      growl.addSuccessMessage($translate.instant('flow.delete-flow-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('flow.delete-flow-failure'));
    });
    $scope.flowVerifies.splice($scope.flowVerifies.indexOf(flowVerify), 1);
  };

  $scope.uploadBackgroundForPublication = function(files, publicationType) {
    return uploadTracker(files.map(function(f) {
      return {
        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/background-images?type=" + publicationType.toLowerCase(),
        file: f,
      };
    }));
  };

  $scope.onFileSelect = function($files, publicationType) {
    $scope.uploadBackgroundForPublication($files, publicationType).then(function(){
      $scope.newTime = new Date().getTime();
      $scope.urlBases[$scope.types.indexOf(publicationType)] = true;
    });
  };

  $scope.removeBackgroundForPublication = function(type){
    $http({
      method: 'DELETE',
      url: config.apiBase + "/files/" + $stateParams.companyId + "_pub_" + type.toLowerCase()
    })
    .success(function() {
      $scope.urlBases[$scope.types.indexOf(type)] = false;
      growl.addSuccessMessage($translate.instant('product.delete-image-success'));
    })
    .error(function() {
      growl.addErrorMessage($translate.instant('product.delete-image-failure'));
    });
  };
}

CompanyTagSuggestionCtrl.resolve = {
  tagSuggestions: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryTagSuggestions({companyId: $stateParams.companyId}).$promise;
  }],
  flowVerifies: ['$stateParams', 'CompanyFlowVerifiesService', function($stateParams, CompanyFlowVerifiesService) {
    return CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise;
  }]
};

module.exports = CompanyTagSuggestionCtrl;

angular.module('dokiv')
  .controller('CompanyTagSuggestionCtrl', [
  '$scope',
  '$stateParams',
  'growl',
  '$http',
  '$translate',
  'tagSuggestions',
  'flowVerifies',
  'UploadTracker',
  'config',
  'CompanyUserService',
  'CompanyFlowVerifiesService',
  'CompanyService',
  CompanyTagSuggestionCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/account/CompanyTagSuggestionCtrl.js
// module id = 320
// module chunks = 0